import { Icon } from './Icons.jsx';
import { ComboPrepNote } from './Step4Labs.jsx';

export default function Step6Confirm({ state, onRestart }) {
  const exams = state.exams || [];
  const lab = state.labData;
  const payment = state.payment || {};
  const order = state.order || {};
  const total = payment.total ?? payment.net_amount ?? order.total_amount ?? 0;
  const confirmed = ['confirmed', 'received', 'paid'].includes(payment.status);
  const multi = (state.orders || []).length > 1;

  return (
    <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', background: 'var(--bg)' }}>
      <div className="hero-brand" style={{ padding: '50px 20px 30px', textAlign: 'center', color: 'var(--white)', background: 'linear-gradient(160deg, var(--midnight), var(--midnight-90) 55%, var(--navy-3) 100%)', position: 'relative', overflow: 'hidden' }}>
        <svg width="240" height="240" style={{ position: 'absolute', right: -60, top: -40, opacity: 0.15 }}>
          {[...Array(5)].map((_, i) => <circle key={i} cx="120" cy="120" r={24 + i*20} stroke="var(--green)" strokeWidth="1" fill="none"/>)}
        </svg>
        <div style={{ width: 64, height: 64, borderRadius: '50%', background: confirmed ? 'var(--green)' : 'var(--yellow)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12, position: 'relative', zIndex: 1 }}>
          {confirmed ? <Icon.check size={32} color="var(--midnight)" strokeWidth={3}/> : <Icon.clock size={30} color="var(--midnight)"/>}
        </div>
        <h1 style={{ fontSize: 24, fontWeight: 700, color: 'var(--white)', position: 'relative', zIndex: 1 }}>
          {confirmed ? 'Confirmado!' : 'Pedido criado!'}
        </h1>
        {multi && (
          <div style={{ color: 'var(--overlay-white-80)', fontSize: 13, marginTop: 6, position: 'relative', zIndex: 1 }}>
            {state.orders.length} pedidos — um por laboratório (detalhes abaixo)
          </div>
        )}
        {!multi && order.protocol_number && (
          <div style={{ color: 'var(--overlay-white-80)', fontSize: 13, marginTop: 6, position: 'relative', zIndex: 1 }}>
            Protocolo <b style={{ color: 'var(--white)' }}>{order.protocol_number}</b>
          </div>
        )}
        {!multi && confirmed && order.security_token && (
          <div style={{ color: 'var(--overlay-white-80)', fontSize: 13, marginTop: 2, position: 'relative', zIndex: 1 }}>
            Token <b style={{ color: 'var(--white)' }}>{order.security_token}</b>
          </div>
        )}
        <div style={{ color: 'var(--overlay-white-80)', fontSize: 13, marginTop: 2, position: 'relative', zIndex: 1 }}>
          {confirmed
            ? `R$ ${Number(total).toFixed(2).replace('.', ',')} aprovado`
            : `R$ ${Number(total).toFixed(2).replace('.', ',')} · aguardando confirmação do pagamento`}
        </div>
        {confirmed && order.security_token && (
          <div style={{ color: 'var(--overlay-white-65)', fontSize: 11.5, marginTop: 8, maxWidth: 280, marginLeft: 'auto', marginRight: 'auto', position: 'relative', zIndex: 1 }}>
            Guarde esse código: ele será solicitado no laboratório para confirmar a realização do seu pedido.
          </div>
        )}
      </div>

      <div style={{ padding: '18px 16px', display: 'flex', flexDirection: 'column', gap: 12 }}>
        {!confirmed && (
          <div className="card" style={{ padding: 14, background: 'var(--warning-tint-2)', border: '1px solid var(--overlay-warning-50)' }}>
            <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
              <Icon.info size={16} color="var(--warning-dark)" style={{ flexShrink: 0, marginTop: 2 }}/>
              <div style={{ fontSize: 13, color: 'var(--warning-darkest)' }}>
                {payment.method === 'boleto'
                  ? 'O pedido será liberado após a compensação do boleto (até 1 dia útil).'
                  : 'O pedido será liberado assim que o pagamento for confirmado.'}
              </div>
            </div>
            {payment.boleto_url && (
              <a href={payment.boleto_url} target="_blank" rel="noreferrer" className="btn btn-outline" style={{ marginTop: 10, display: 'inline-flex', gap: 6, alignItems: 'center' }}>
                <Icon.download size={14}/> Abrir boleto
              </a>
            )}
          </div>
        )}

        {(state.orders || []).length > 1 && (
          <div className="card" style={{ padding: 14 }}>
            <div style={{ fontSize: 10, color: 'var(--text-muted)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em', fontFamily: 'var(--font-display)' }}>
              Seus exames em {state.orders.length} laboratórios · um pagamento
            </div>
            <ComboPrepNote bloodLabCount={state.combo?.bloodLabCount || 0}/>
            {state.orders.map(o => (
              <div key={o.id} style={{ marginTop: 10, padding: 10, borderRadius: 10, background: 'var(--marble-soft)' }}>
                <div style={{ fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 14 }}>{o.partner_name}</div>
                {o.partner_address && <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{o.partner_address}</div>}
                <div style={{ fontSize: 12, marginTop: 4 }}>Protocolo <b>{o.protocol_number}</b>{confirmed && o.security_token && <> · Token <b>{o.security_token}</b></>}</div>
                <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 2 }}>{(o.items || []).map(i => i.tuss_name).join(' · ')}</div>
              </div>
            ))}
          </div>
        )}

        {lab && (
          <div className="card" style={{ padding: 14 }}>
            <div style={{ fontSize: 10, color: 'var(--text-muted)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em', fontFamily: 'var(--font-display)' }}>Laboratório</div>
            <div style={{ fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 15, marginTop: 2 }}>{lab.name}</div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 4 }}>{lab.address}</div>
            {lab.hours && <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{lab.hours}</div>}
            {lab.phone && <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{lab.phone}</div>}
          </div>
        )}

        {(order.prescriptions || []).length > 0 && (
          <div className="card" style={{ padding: 14 }}>
            <h3 style={{ fontSize: 14, fontWeight: 600, marginBottom: 10 }}>
              {order.prescriptions.length > 1 ? 'Pedidos médicos' : 'Pedido médico'}
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {order.prescriptions.map(p => (
                <div key={p.id} style={{ display: 'flex', gap: 10, padding: 10, borderRadius: 10, background: 'var(--marble-soft)', alignItems: 'flex-start' }}>
                  <Icon.file size={14} color="var(--brand-primary)" style={{ marginTop: 2, flexShrink: 0 }}/>
                  <div>
                    <div style={{ fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 13 }}>{p.doctor_name || 'Médico não identificado'}</div>
                    <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 1 }}>
                      {[p.doctor_crm, p.doctor_specialty].filter(Boolean).join(' · ') || '—'}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="card" style={{ padding: 14 }}>
          <h3 style={{ fontSize: 14, fontWeight: 600, marginBottom: 10 }}>Exames e preparo</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {exams.map(e => (
              <div key={e.code} style={{ display: 'flex', gap: 10, padding: 10, borderRadius: 10, background: 'var(--marble-soft)', alignItems: 'flex-start' }}>
                <Icon.flask size={14} color="var(--brand-primary)" style={{ marginTop: 2, flexShrink: 0 }}/>
                <div>
                  <div style={{ fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 13 }}>{e.name}</div>
                  <div style={{ fontSize: 11, color: 'var(--text-subtle)', marginTop: 2 }}>
                    {e.fromOrder === false ? 'Compra avulsa' : 'Pedido médico'}
                  </div>
                  {e.note && (
                    <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 3 }}>
                      <b>Orientações de preparo:</b> {e.note}
                    </div>
                  )}
                </div>
              </div>
            ))}
            <div style={{ display: 'flex', gap: 10, padding: 10, borderRadius: 10, background: 'var(--marble-soft)', alignItems: 'flex-start' }}>
              <Icon.file size={14} color="var(--midnight)" style={{ marginTop: 2, flexShrink: 0 }}/>
              <div>
                <div style={{ fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 13 }}>Leve com você</div>
                <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 1 }}>Pedido médico original e documento com foto.</div>
              </div>
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 10 }}>
          <button className="btn btn-primary" onClick={onRestart}>Voltar ao início <Icon.arrowR size={16} color="var(--white)"/></button>
        </div>
      </div>
    </div>
  );
}
